import API from "../../api/api";
import React, { Component } from "react";
import { States } from "../../components";
import AddIcon from "@material-ui/icons/Add";
import "../../styles/css/users/UserCreationForm.css";
import ErrorOutileIcon from "@material-ui/icons/ErrorOutline";
import CircularProgress from "@material-ui/core/CircularProgress";

// const userRole = localStorage.getItem("userRole");
const userRoleId = localStorage.getItem("userRoleId");

class UserCreationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      states: States,
      email: "",
      newUserRole:
        userRoleId === "1"
          ? "1"
          : userRoleId === "2"
          ? "3"
          : userRoleId === "4"
          ? "5"
          : "0",

      emailEmpty: false,
      newUserRoleEmpty: false,

      isCreationLoading: false,
      isSubmitted: false,
      userCreationSuccess: true,

      buttonDisabled: false,
    };
  }

  inputHandleChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;

    this.setState(
      {
        [name]: value,
        [`${name}Empty`]: false,
      },
      () => this.checkMinus(name, value)
    );
  };

  checkMinus = (name, value) => {
    if (name === "contactNo" && value !== null && value < 0) {
      this.setState({ contactNoMinus: true });
    } else if (name === "contactNo" && value !== null && value >= 0) {
      this.setState({ contactNoMinus: false });
    }
    if (name === "zipcode" && value !== null && value < 0) {
      this.setState({ zipcodeMinus: true });
    } else if (name === "zipcode" && value !== null && value >= 0) {
      this.setState({ zipcodeMinus: false });
    }
  };

  stateHandleChange = (e) => {
    this.setState({
      newUserRole: e.target.value,
      newUserRoleEmpty: false,
    });
  };

  submitUserCreation = (e) => {
    e.preventDefault();

    this.setState({
      isCreationLoading: true,
      buttonDisabled: true,
    });

    const Userdata = {
      email: this.state.email,
    };

    Object.keys(Userdata).forEach((key) => {
      if (Userdata[key] === "") {
        this.setState({
          [`${key}Empty`]: true,
        });
      } else {
        this.setState({
          [`${key}Empty`]: false,
        });
      }
    });
    if (this.state.state === "null") {
      this.setState({
        stateEmpty: true,
      });
    } else {
      this.setState({
        stateEmpty: false,
      });
    }

    const sendData = {
      email: this.state.email,
      user_role_id: this.state.newUserRole,
    };

    if (this.state.email !== "") {
      API.post("user/internal-sign-up", sendData)
        .then((res) => {
          console.log("res", res);
          this.setState({
            isCreationLoading: false,
            buttonDisabled: false,
          });
          this.showCreationMessage(true);
          this.clearAllFields();
          this.props.newId(res.data.response);
        })
        .catch((err) => {
          console.log("AXIOS ERROR: ", err);
          this.setState({
            isCreationLoading: false,
            buttonDisabled: false,
          });
          this.showCreationMessage(false);
        });
    } else {
      this.setState({
        isCreationLoading: false,
        buttonDisabled: false,
      });
    }
  };

  clearAllFields = () => {
    this.setState({
      email: "",

      emailEmpty: false,
    });
  };

  showCreationMessage = (success) => {
    this.setState({
      isSubmitted: true,
      userCreationSuccess: success ? true : false,
    });
    setTimeout(() => {
      this.setState({
        isSubmitted: false,
        userCreationSuccess: true,
      });
    }, 3000);
  };

  render() {
    const {
      // states,
      isCreationLoading,
      isSubmitted,
      userCreationSuccess,
      buttonDisabled,
    } = this.state;

    return (
      <div className="">
        <div className="headerCardMain userCreationMain">
          <div>
            <form onSubmit={this.submitUserCreation}>
              <div className="formRow">
                <div className="formInputGroup customWidth2">
                  <div className="formInputLabel">Email*</div>
                  <div className="formInput">
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={this.state.email}
                      className="textInput"
                      onChange={this.inputHandleChange}
                    />
                    <div
                      className="ErrorLog"
                      style={{
                        display: this.state.emailEmpty ? "block" : "none",
                      }}
                    >
                      <span>Email is required</span>
                    </div>
                  </div>
                </div>
              </div>
              {userRoleId === "1" ? (
                <div className="formRow">
                  <div className="formInputGroup customWidth2">
                    <div className="formInputLabel">User Role*</div>
                    <div className="formInput">
                      <select
                        id="newUserRole"
                        name="newUserRole"
                        value={this.state.state}
                        className="textInput"
                        onChange={this.stateHandleChange}
                      >
                        <option value={1} key={1}>
                          Admin
                        </option>
                        <option value={2} key={1}>
                          Title Company Admin
                        </option>
                        <option value={4} key={1}>
                          Survey Admin
                        </option>
                      </select>
                      <div
                        className="ErrorLog"
                        style={{
                          display: this.state.stateEmpty ? "block" : "none",
                        }}
                      >
                        <span>State is required</span>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
              <div className="formRow submitRow">
                <div className="userCreationMessageDiv">
                  <div className="userCreationMessage" id="userCreationMessage">
                    {isSubmitted ? (
                      userCreationSuccess ? (
                        <div className="messageBody userCreationSuccessColor">
                          <div className="messageAction">
                            <ErrorOutileIcon />
                          </div>
                          <div className="userCreationSuccess">
                            User has been added successfully
                          </div>
                        </div>
                      ) : (
                        <div className="messageBody userCreationFailColor">
                          <div className="messageAction">
                            <ErrorOutileIcon />
                          </div>
                          <div className="userCreationFail">
                            The email has already been taken
                          </div>
                        </div>
                      )
                    ) : null}
                  </div>
                  <button
                    type="submit"
                    className="formSubmit"
                    disabled={buttonDisabled}
                  >
                    {isCreationLoading ? (
                      <CircularProgress className="circularColor1" />
                    ) : (
                      <div>
                        <AddIcon />
                        <span>Create a user</span>
                      </div>
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default UserCreationForm;



// WEBPACK FOOTER //
// ./src/pages/Users/UserCreationForm.js